<template>
	<div :class="['job-vita--grid-area', {'has-title': area.title}]">
		<div v-if="area.title" class="job-vita--grid-area-title">
			{{ area.title }}
			<template v-if="area.subTitle"><br />{{ area.subTitle }}</template>
		</div>
		<div v-if="area.predefinedValue" class="job-vita--grid-area-predefined-value">
			<PredefinedValue
				:predefined-value="area.predefinedValue"
			/>
		</div>
		<div v-if="area.needsUpgrade" class="job-vita--grid-area-needs-upgrade">
			<Button
				text="Details"
				secondary
				smaller
				@click="showUpgradePopUp = true"
			/>
		</div>
		<div class="job-vita--grid-area-sections">
			<Section
				v-for="section in area.sections"
				:key="section.id"
				:section="section"
				:job-profile-id="jobProfileId"
				:pseudonym-id="pseudonymId"
				@upgrade="onUpgrade"
			/>
		</div>
		<UpgradePopUp
			v-if="showUpgradePopUp"
			:job-profile-id="jobProfileId"
			:pseudonym-id="pseudonymId"
			@upgrade="onUpgrade"
			@hidden="showUpgradePopUp = false"
		/>
	</div>
</template>

<script>
import Section from "@/vue/application/job/vita/grid/Section";
import Button from "@/vue/common/Button";
import UpgradePopUp from "@/vue/permission/UpgradePopUp";
import PredefinedValue from "@/vue/application/job/vita/grid/PredefinedValue";

export default {

	components: {
		UpgradePopUp,
		PredefinedValue,
		Button,
		Section,
	},

	props: {
		jobProfileId: {
			type: String,
			required: true,
		},
		pseudonymId: {
			type: String,
			required: false,
		},
		area: {
			type: Object,
			required: true,
		}
	},

	data ()
	{
		return {
			showUpgradePopUp: false,
		};
	},

	methods: {
		onUpgrade ()
		{
			this.showUpgradePopUp = false;

			this.$emit('upgrade');
		}
	}
}
</script>
